import { useMemo } from "react";
import { useCurrentSection } from "../useCurrentSection";

/**
 * Hook that computes the navigation event category from the current section.
 * Returns the section ID if available, otherwise returns a step-based identifier.
 *
 * @returns The category string to be used for navigation analytics events
 */
export const useNavEventCategory = (): string => {
  const { currentSection, currentSectionIndex } = useCurrentSection();

  const category = useMemo(
    () => currentSection?.id ?? `step-${currentSectionIndex + 1}`,
    [currentSection?.id, currentSectionIndex],
  );

  return category;
};
